import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBaseInputFieldStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.padding(tokens.spacingVerticalXS, '0'),
        width: '100%'
    },
    label: {
        fontSize: tokens.fontSizeBase400
    },
    inputField: {
        ...shorthands.borderColor(tokens.colorNeutralBackground2),
        width: '100%',
        marginTop: tokens.spacingVerticalS
    },
    requiredAsterisk: {
        color: tokens.colorPaletteRedForeground1
    }
});
